"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var moment_1 = require("moment");
var vivien_1 = require("vivien");
var calcAge_1 = require("./calcAge");
var indexPaxField_1 = require("./indexPaxField");
// load data from the backend-API and fill the store with it
function setFieldGlobally(store, field) {
    var paxe = store.getters['all'];
    var index = 0;
    for (var _i = 0, paxe_1 = paxe; _i < paxe_1.length; _i++) {
        var pax = paxe_1[_i];
        if (pax[field.name] !== undefined &&
            pax[field.name].touched) {
            store.dispatch('setField', new SingleField(index, field.name, field.value));
        }
        index++;
    }
}
function setField(store, field) {
    store.dispatch('validateField', field);
    store.dispatch('validate');
}
// tslint:disable-next-line:cyclomatic-complexity
function validateField(store, field) {
    return __awaiter(this, void 0, void 0, function () {
        var rules, allRules, paxField, _i, rules_1, rule, birthday, nationalityCode, documents, erpInfos, defaultErpInfo1, defaultErpInfo2, paxField_1, defaultErpInfo;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    rules = [];
                    allRules = store.getters['validations'];
                    if (allRules !== undefined && allRules[field.name] !== undefined) {
                        rules = allRules[field.name][0].rules;
                    }
                    if (!(field.index !== null &&
                        field.index !== undefined &&
                        field.index.toLocaleString() !== '')) return [3 /*break*/, 6];
                    paxField = lodash_1.cloneDeep(store.getters['all'][field.index][field.name]);
                    if (paxField === undefined) {
                        return [2 /*return*/];
                    }
                    paxField.value = field.value;
                    paxField.valid = true;
                    paxField.error = null;
                    paxField.errorShort = null;
                    paxField.warning = null;
                    if (field.name === 'birthday') {
                        paxField = validateBirthday(paxField, field.value, field.index, store.getters['cruiseDate'], allRules['age'], allRules['birthday'], store.getters['transportationType'], store.getters['checkPaxChildAge']);
                    }
                    if (field.name === 'erpConfirm') {
                        paxField = validateErpConfirm(paxField);
                    }
                    else {
                        for (_i = 0, rules_1 = rules; _i < rules_1.length; _i++) {
                            rule = rules_1[_i];
                            paxField = checkRule(rule, paxField, field.value);
                        }
                    }
                    store.commit('SET_FIELD', new indexPaxField_1.IndexPaxField(field.index, paxField));
                    birthday = store.getters['all'][field.index]['birthday'];
                    nationalityCode = store.getters['all'][field.index]['nationalityCode'];
                    if (!(birthday.valid && nationalityCode.valid)) return [3 /*break*/, 5];
                    return [4 /*yield*/, fetchErpInfo(store, {
                            birthday: birthday.value,
                            nationality: nationalityCode.value,
                        })];
                case 1:
                    documents = _a.sent();
                    if (!(documents && documents['paxPortfolios'])) return [3 /*break*/, 3];
                    return [4 /*yield*/, Promise.all(lodash_1.map(documents['paxPortfolios'], function (paxPortFolio) { return __awaiter(_this, void 0, void 0, function () {
                            var erpId, erpPDF;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        erpId = paxPortFolio['portfolio']['id'];
                                        return [4 /*yield*/, fetchPDFcontent(store, erpId)];
                                    case 1:
                                        erpPDF = _a.sent();
                                        return [2 /*return*/, paxPortFolio['portfolio']['status'] === 'VALID'
                                                ? {
                                                    erpId: erpId,
                                                    erpLink: paxPortFolio['portfolio']['versions'][0]['link'],
                                                    erpText: erpPDF,
                                                }
                                                : {
                                                    erpId: 'ErpError',
                                                    erpLink: null,
                                                    erpText: null,
                                                }];
                                }
                            });
                        }); }))];
                case 2:
                    erpInfos = _a.sent();
                    store.commit('SET_ERP_INFOS', { key: field.index, infos: erpInfos });
                    return [3 /*break*/, 4];
                case 3:
                    defaultErpInfo1 = {
                        erpId: 'ErpError',
                        erpLink: null,
                        erpText: null,
                    };
                    defaultErpInfo2 = {
                        erpId: 'ErpError',
                        erpLink: null,
                        erpText: null,
                    };
                    store.commit('SET_ERP_INFOS', {
                        key: field.index,
                        infos: [defaultErpInfo1, defaultErpInfo2],
                    });
                    paxField_1 = lodash_1.cloneDeep(store.getters['all'][field.index]['erpConfirm']);
                    paxField_1.error = false;
                    paxField_1.touched = false;
                    paxField_1.valid = false;
                    paxField_1.value = null;
                    paxField_1.warning = false;
                    store.commit('SET_FIELD', new indexPaxField_1.IndexPaxField(field.index, paxField_1));
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    // delete erpInfo settings
                    if (store.getters['all'][field.index]['erpInfo']['erpId']) {
                        defaultErpInfo = {
                            erpId: null,
                            erpLink: null,
                            erpText: null,
                        };
                        store.commit('SET_ERP_INFO', { key: field.index, info: defaultErpInfo });
                    }
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    });
}
function fetchErpInfo(store, pax) {
    return __awaiter(this, void 0, void 0, function () {
        var allDocuments, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, vivien_1.client.cruise(store.rootGetters['booking/general/cruise'].id, [pax], 'AID')];
                case 1:
                    allDocuments = _a.sent();
                    return [2 /*return*/, allDocuments];
                case 2:
                    err_1 = _a.sent();
                    console.log(err_1);
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function fetchPDFcontent(_store, erpId) {
    return __awaiter(this, void 0, void 0, function () {
        var content, _a, err_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    _a = atob;
                    return [4 /*yield*/, vivien_1.client.pdf(erpId)];
                case 1:
                    content = _a.apply(void 0, [_b.sent()]);
                    return [2 /*return*/, content];
                case 2:
                    err_2 = _b.sent();
                    console.log(err_2);
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    });
}
// tslint:disable-next-line:cyclomatic-complexity
function validateBirthday(paxField, birthday, index, departure, ageRules, birthdayRules, transportationType, checkPaxChildAge) {
    if (birthdayRules !== undefined && paxField.error === null) {
        for (var _i = 0, birthdayRules_1 = birthdayRules; _i < birthdayRules_1.length; _i++) {
            var rule = birthdayRules_1[_i];
            paxField = checkRule(rule, paxField, birthday);
        }
    }
    if (!moment_1.utc(birthday, 'DD.MM.YYYY').isValid()) {
        paxField.valid = false;
        paxField.error = 'Bitte geben Sie ein gültiges Datum ein.';
    }
    if (paxField.error === null &&
        moment_1.utc(birthday, 'DD.MM.YYYY').isSameOrAfter(moment_1.utc())) {
        paxField.valid = false;
        paxField.error = 'Das Geburtsdatum liegt in der Zukunft.';
    }
    var ageWhenCruiseStart = calcAge_1.calcAge(birthday, departure);
    var currentAge = calcAge_1.calcAge(birthday, moment_1.utc().format('DD.MM.YYYY'));
    if (paxField.error === null && index === 0 && currentAge < 18) {
        paxField.valid = false;
        paxField.error = 'Die erste Person muss mindestens 18 Jahre alt sein.';
        paxField.errorShort = '1. Person muss mindestens 18 Jahre alt sein.';
    }
    if (checkPaxChildAge && paxField.error === null && index > 0 && ageWhenCruiseStart < 12) {
        paxField.valid = false;
        paxField.error = 'Aufgrund behördlicher Vorgaben darf leider nur eine begrenzte Anzahl ungeimpfter Gäste unter 12 Jahren mitreisen. Leider ist das Kontingent für diese Reise bereits erschöpft.';
        paxField.errorShort = 'Person muss mindestens 12 Jahre alt sein.';
    }
    if (paxField.error === null && ageWhenCruiseStart < 2) {
        paxField.valid = false;
        paxField.error =
            'Kinder unter 2 Jahren buchen Sie in unserem <a href="tel:038120270719" title="0381/ 20 27 07 19">Kundencenter.</a>';
        paxField.errorShort =
            'Kinder unter 2 Jahren: Im <a href="tel:038120270719" title="0381/ 20 27 07 19">Kundencenter</a> buchen.';
    }
    if (paxField.error === null &&
        ageWhenCruiseStart >= 15 &&
        ageWhenCruiseStart < 16 &&
        transportationType === 'rail') {
        paxField.warning = 'Bahnpreis hat sich geändert';
    }
    if (ageRules !== undefined && paxField.error === null) {
        for (var _a = 0, _b = ageRules[0].rules; _a < _b.length; _a++) {
            var rule = _b[_a];
            paxField = checkRule(rule, paxField, calcAge_1.calcAge(birthday, departure).toString());
        }
    }
    return paxField;
}
function validateErpConfirm(paxField) {
    if (!paxField.touched && (paxField.value === null || paxField.value === '')) {
        paxField.valid = false;
        return paxField;
    }
    if (paxField.value === null || paxField.value === '') {
        paxField.error = 'Bitte zustimmen';
        paxField.valid = false;
    }
    else {
        paxField.valid = true;
    }
    return paxField;
}
// tslint:disable-next-line:cyclomatic-complexity
function checkRule(rule, paxField, value) {
    if (paxField.error === null) {
        if ((rule.regex !== undefined &&
            !rule.triggerIfMatch &&
            !new RegExp(rule.regex, 'i').test(value)) ||
            (rule.triggerIfMatch && new RegExp(rule.regex, 'i').test(value))) {
            if (rule.type === 'notice') {
                paxField.warning = rule.message;
            }
            else {
                paxField.valid = false;
                paxField.error = rule.message;
            }
        }
    }
    return paxField;
}
function validate(store) {
    var paxe = store.getters['all'];
    var valid = true;
    for (var _i = 0, paxe_2 = paxe; _i < paxe_2.length; _i++) {
        var pax = paxe_2[_i];
        if (!allFieldsValid(pax)) {
            valid = false;
        }
    }
    store.commit('SET_VALID', valid);
}
function mark(store) {
    var index = 0;
    for (var _i = 0, _a = store.getters['all']; _i < _a.length; _i++) {
        var pax = _a[_i];
        markPax(store, pax, index);
        index++;
    }
}
function importFormValidations(store, formValidations) {
    store.commit('IMPORT_FORM_VALIDATIONS', formValidations);
}
function setDepatureDate(store, departureDate) {
    store.commit('SET_DEPARTURE_DATE', departureDate);
}
function setCheckPaxChildAge(store, checkAge) {
    store.commit('SET_CHECK_PAX_CHILD_AGE', checkAge);
}
function resetStore(store) {
    store.commit('RESET_STATE');
}
// export everything compliant to the vuex specification for actions
exports.default = {
    importFormValidations: importFormValidations,
    mark: mark,
    setField: setField,
    setFieldGlobally: setFieldGlobally,
    setDepatureDate: setDepatureDate,
    setCheckPaxChildAge: setCheckPaxChildAge,
    validate: validate,
    validateField: validateField,
    resetStore: resetStore,
    fetchErpInfo: fetchErpInfo,
};
function markPax(store, pax, index) {
    if (!pax.birthday.touched) {
        store.dispatch('setField', new SingleField(index, 'birthday', pax.birthday.value));
    }
    if (!pax.firstName.touched) {
        store.dispatch('setField', new SingleField(index, 'firstName', pax.firstName.value));
    }
    if (!pax.lastName.touched) {
        store.dispatch('setField', new SingleField(index, 'lastName', pax.lastName.value));
    }
    if (!pax.nationalityCode.touched) {
        store.dispatch('setField', new SingleField(index, 'nationalityCode', pax.nationalityCode.value));
    }
    if (!pax.sex.touched) {
        store.dispatch('setField', new SingleField(index, 'sex', pax.sex.value));
    }
    if (!pax.erpConfirm.touched) {
        store.dispatch('setField', new SingleField(index, 'erpConfirm', pax.erpConfirm.value));
    }
}
function allFieldsValid(pax) {
    // console.log('pax.erpConfirm.valid', pax.erpConfirm.valid)
    if (pax.birthday.valid &&
        pax.firstName.valid &&
        pax.lastName.valid &&
        pax.nationalityCode.valid &&
        pax.sex.valid &&
        pax.erpConfirm.valid) {
        return true;
    }
    return false;
}
var SingleField = /** @class */ (function () {
    function SingleField(index, name, value) {
        this.index = index;
        this.name = name;
        this.value = value;
    }
    return SingleField;
}());
//# sourceMappingURL=actions.js.map